import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  SelectPicker,
  Checkbox,
  Radio,
  CheckPicker,
} from "rsuite";
import { Form, Field } from "react-final-form";
import { updateIn } from "json-immut/updateIn";
import { render } from "react-dom";
import { UserServices } from "../../../core/services/UserServices";
import { CustomerServices } from "../../../core/services/CustomerServices";
import { HelperServices } from "../../../core/services/HelperServices";
import "./Customer.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, debounce, padStart } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import {
  messageTypeArr,
  roleTypeArr,
  onOffArr,
  statusArr,
  genderArr,
  custSourceArr,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "../../validators/ValidatorCustom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  getPincodeForArea,
  getPrimaryAddress,
  getStdCodeForCountry,
  getStdCodesFromCountryList,
  isEmptyVal,
  isNotEmpty,
  isNotNull,
  zeroFill,
} from "../../../utils/helpers";
import moment, { RFC_2822 } from "moment";
function CampaignCustomer({
  forCompany,
  forStore,
  onAdd,
  withHeader = true,
  withCancelButton = true,
}: {
  forCompany?: number;
  forStore?: number;
  onAdd?: Function;
  withHeader?: boolean;
  withCancelButton?: boolean;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(false);
  const countryList = useSelector((state: any) => state.country.data);
  const stdCodeList = getStdCodesFromCountryList(countryList);
  const params: any = useParams();
  const selectedCompany = useSelector((state: any) => state.company);
  const searchData = useSelector((state: any) => state.user);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [buildingList, setBuildingList] = useState([]);
  const [editCustomerCompany, setEditCustomerCompany] = useState<number>();
  const defaultSettings = UtilityServices.getLoggedInUser("settings");
  let mob,
    nm = "";
  let searchString = searchData.searchString;
  if (!isNaN(Number(searchString))) {
    mob = searchString;
  } else {
    nm = searchString;
  }
  const [formData, setFormData] = useState<any>({
    email: "",
    name: nm,
    fname: "",
    lname: "",
    country_code: !isEmptyVal(defaultSettings["default_country"])
      ? getStdCodeForCountry(defaultSettings["default_country"], countryList)
      : "91",
    mobile: mob,
    comp_id: "",
    city_id: "",
    country_id: "",
    state_id: "",
    building: "",
    building_id: "",
    area_name: "",
    area_id: "",
    pincode: "",
    customer_type: "standard",
    retention_type: "prospect",
    customer_source_id: custSourceArr.campaign,
    status: statusArr.active,
    gender: genderArr.female,
    new_area: onOffArr.off,
    new_building: onOffArr.off,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [cityNotFound, setCityNotFound] = useState(false);
  const [stateNotFound, setSateNotFound] = useState(false);
  const [areaNotFound, setAreaNotFound] = useState(false);
  const [buildingNotFound, setBuildingNotFound] = useState(false);
  const [createNewArea, setCreateNewArea] = useState(false);
  const [createNewBuilding, setCreateNewBuilding] = useState(false);
  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [isUsernameAllowed, setIsUsernameAllowed] = useState(true);

  let [decryptedParams] = useDecryptedParams(params);

  function handleFormChanges(data: any, form?: any) {
    if (form) {
      let frm = updateIn(form.getState().values, [data.path], data.value);
      setFormData(frm);
    }
  }

  async function init() {
    try {
      if (decryptedParams.id) {
        setLoading(true);
        const response: any = await CustomerServices.viewCustomer(
          +decryptedParams.id
        );
        const respData = get("data.data", response);
        const primaryAddress = getPrimaryAddress(respData.user);
        const userInfo = isNotEmpty(respData.user) ? respData.user : [];
        let obj = { ...formData };
        Object.keys(obj).map((formKeys) => {
          if (respData[formKeys]) {
            obj[formKeys] = respData[formKeys];
          }
          if (!respData[formKeys] && primaryAddress[formKeys]) {
            obj[formKeys] = primaryAddress[formKeys];
          }
          if (!respData[formKeys] && userInfo[formKeys]) {
            obj[formKeys] = userInfo[formKeys];
          }
          if (formKeys === "building") {
            obj[formKeys] = primaryAddress["building_name"];
          }
        });

        if (obj?.company_id > 0) {
          setEditCustomerCompany(obj.company_id);
        }
        setFormData({ ...obj });
        preSelectFields(obj);
        setLoading(false);
      } else {
        initValues();
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });

      navigate(ContentRoutes.CAMPAIGNS);
    }
  }

  async function preSelectFields(obj: any) {
    if (obj.country_id) {
      handleCountryChange(obj.country_id);
    }
    if (obj.state_id) {
      handleStateChange(obj.state_id);
    }
    if (obj?.city_id && obj?.state_id && obj?.country_id) {
      handleCityChange(obj.city_id);
    }
    if (obj?.area_id && obj?.city_id && obj?.state_id && obj?.country_id) {
      handleAreaChange(obj.area_id);
    }
    if (
      obj?.building_id &&
      obj?.area_id &&
      obj?.city_id &&
      obj?.state_id &&
      obj?.country_id
    ) {
      handleBuildingChange(obj.building_id);
    }
  }

  function initValues() {
    if (!decryptedParams?.id) {
      loadUserDefaultSettings();
    }
  }

  function loadUserDefaultSettings() {
    setLoading(true);

    let obj = { ...formData };
    if (!isEmptyVal(defaultSettings["default_country"])) {
      obj["country_id"] = parseInt(defaultSettings["default_country"]);
    }
    if (!isEmptyVal(defaultSettings["default_state"])) {
      obj["state_id"] = parseInt(defaultSettings["default_state"]);
    }
    if (!isEmptyVal(defaultSettings["default_city"])) {
      obj["city_id"] = parseInt(defaultSettings["default_city"]);
    }
    if (!isEmptyVal(defaultSettings["default_area"])) {
      obj["area_id"] = parseInt(defaultSettings["default_area"]);
    }
    setFormData({ ...obj });
    preSelectFields(obj);
    setLoading(false);
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {
    if (!decryptedParams?.id) {
    }
  }, [selectedCompany]);

  function getCompanyId() {
    let compId = 0;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (decryptedParams.id && editCustomerCompany) {
      compId = editCustomerCompany;
    } else if (selectedCompany?.id && !decryptedParams.id) {
      compId = selectedCompany.id;
    }
    return compId;
  }

  async function handleCountryChange(countryId: any, form?: any) {
    if (form) {
      form.change("country_id", countryId);
      form.change("state_id", "");
      form.change("city_id", "");
      form.change("building", "");
      form.change("area_name", "");
      form.change("area_id", "");
      form.change("building_id", "");
      setCityList([]);
      setAreaList([]);
      setBuildingList([]);
    }

    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      const respData = get("data.data", stateRes);
      setStateList(respData);
      setSateNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleStateChange(stateId: any, form?: any) {
    if (form) {
      form.change("state_id", stateId);
      form.change("city_id", "");
      form.change("building", "");
      form.change("area_name", "");
      form.change("area_id", "");
      form.change("building_id", "");
      setAreaList([]);
      setBuildingList([]);
    }

    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      const respData = get("data.data", res);
      setCityList(respData);
      setCityNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCityChange(cityId: any, form?: any) {
    if (form) {
      form.change("city_id", cityId);
      form.change("building", "");
      form.change("area_name", "");
      form.change("area_id", "");
      form.change("building_id", "");
      setBuildingList([]);
    }

    try {
      const res = await HelperServices.getAllValidAreas({ city: cityId });
      const respData = get("data.data", res);
      setAreaList(respData);
      setAreaNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleAreaChange(areaId: any, form?: any) {
    if (form) {
      form.change("area_id", areaId);
      form.change("building", "");
      form.change("area_name", "");
      form.change("building_id", "");
      form.change("pincode", getPincodeForArea(areaId, areaList));
    }

    try {
      const res = await HelperServices.getAllValidBuildings({ area: areaId });
      const respData = get("data.data", res);
      setBuildingList(respData);
      setBuildingNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleBuildingChange(buildingId: any, form?: any) {
    if (form) {
      form.change("building_id", buildingId);
    }
  }

  function resetSelectionFor(resetFor: string, form?: any) {
    switch (resetFor) {
      case "country":
        form.change("country_id", "");
        form.change("state_id", "");
        form.change("city_id", "");
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setStateList([]);
        setCityList([]);
        setAreaList([]);
        setBuildingList([]);
        break;
      case "state":
        form.change("state_id", "");
        form.change("city_id", "");
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setCityList([]);
        setAreaList([]);
        setBuildingList([]);
        break;
      case "city":
        form.change("city_id", "");
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setAreaList([]);
        setBuildingList([]);
        break;
      case "area":
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setBuildingList([]);
        break;
      case "building":
        form.change("building", "");
        form.change("building_id", "");
        break;
    }
  }

  async function saveCustomer(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await CustomerServices.updateCustomer(+id, form);
      } else {
        response = await CustomerServices.createCustomer(form);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      if (onAdd !== undefined) {
        onAdd(response?.data?.data);
      } else {
        navigate(ContentRoutes.CAMPAIGNS);
      }
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const dbounceUsername = useCallback(
    debounce(500, (value: string) => {
      checkUserName(value);
    }),
    []
  );

  async function checkUserName(name: string) {
    if (decryptedParams.id) return;
    try {
      const res = await UserServices.checkUserNameAvailablity({
        username: name,
      });
      setIsUsernameAllowed(false);
    } catch (error: any) {
      setIsUsernameAllowed(true);
    }
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (isNotNull(val[key])) form.append(key, val[key]);
    }
    if (isEmptyVal(form.get("mobile"))) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("MOBILE").toLowerCase(),
        }),
      });
      return;
    }

    if (!isEmptyVal(form.get("name"))) {
      const name = form.get("name")?.toString();

      if (name) {
        const nameArr = name.split(" ");

        if (nameArr.length > 0) {
          form.set("fname", nameArr[0]);
        }
        if (nameArr.length > 1) {
          let lname = "";
          for (let i = 1; i < nameArr.length; i++) {
            lname += nameArr[i] + " ";
          }
          form.set("lname", lname);
        }
      }
    }

    if (!decryptedParams.id) {
      let compId: number = getCompanyId();
      form.set("comp_id", compId.toString());
      if (!compId) {
        UtilityServices.showToaster({
          message: t("REQUIRED_SELECT", {
            field: t("COMPANY").toLowerCase(),
          }),
          type: messageTypeArr.error,
        });
        return;
      }
    }

    if (form.get("new_area") !== "0" && form.get("area_name") != "") {
      form.delete("area_id");
    }

    if (form.get("new_building") !== "0" && form.get("building") != "") {
      form.delete("building_id");
    }

    if (decryptedParams.id) {
      form.delete("comp_id");
      form.delete("password");
      form.delete("confirm_password");
      saveCustomer(form, decryptedParams.id);
    } else {
      saveCustomer(form);
    }
  };

  return (
    <div>
      <style>
        {`
          .rs-container-has-sidebar {
            height: 100vh
          }
        `}
      </style>
      <div className="customer">
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            content={t("LOADING")}
            center
            backdrop={true}
          />
        )}
        <Container className="container">
          {withHeader && (
            <Header className="header">
              <h4 className="mb-2">
                {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("CUSTOMER")}
              </h4>
            </Header>
          )}

          <Content className="content customer-create-wrap">
            <Form
              onSubmit={onSubmit}
              validate={(values: any) => {
                const errors: any = {};
                if (values.mobile && values.mobile.length !== 10) {
                  errors.mobile = t("VALID", {
                    entity: t("MOBILE").toLowerCase(),
                  });
                }
                return errors;
              }}
              initialValues={{ ...formData }}
              render={({ handleSubmit, form }) => (
                <form onSubmit={handleSubmit}>
                  <div className="form-part">
                    <div className="flex-container">
                      <Field name="country_code">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>{t("CODE")}</label>
                            <SelectPicker
                              data={stdCodeList}
                              valueKey="country_std_code"
                              labelKey="country_std_code"
                              onSelect={(value, item) => {
                                handleFormChanges(
                                  { path: "country_code", value },
                                  form
                                );
                              }}
                              onClean={(e: any) => {
                                handleFormChanges(
                                  {
                                    path: "country_code",
                                    value: "",
                                  },
                                  form
                                );
                              }}
                              name="country_code"
                              value={formData?.country_code}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field
                        name="mobile"
                        validate={ValidatorCustom.mobilePatternValidation}
                      >
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label className="inline">{t("MOBILE")}*</label>
                            <input {...input} type="text" autoComplete="off" />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="name">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label className="inline">{t("NAME")}</label>
                            <input {...input} type="text" />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="gender">
                        {({ input, meta }) => (
                          <div className="flex-item gndr-item">
                            <label>{t("GENDER")}</label>
                            <Radio
                              onChangeCapture={(e: any) => {
                                if (e.target.checked) {
                                  form.change("gender", genderArr.male);
                                }
                              }}
                              checked={
                                input.value === genderArr.male ? true : false
                              }
                              name="gender"
                              value={genderArr.male}
                            >
                              {t("MALE")}
                            </Radio>
                            <Radio
                              onChangeCapture={(e: any) => {
                                if (e.target.checked) {
                                  form.change("gender", genderArr.female);
                                }
                              }}
                              checked={
                                input.value === genderArr.female ? true : false
                              }
                              name="gender"
                              value={genderArr.female}
                            >
                              {t("FEMALE")}
                            </Radio>
                            <Radio
                              onChangeCapture={(e: any) => {
                                if (e.target.checked) {
                                  form.change("gender", genderArr.trans_gender);
                                }
                              }}
                              checked={
                                input.value === genderArr.trans_gender
                                  ? true
                                  : false
                              }
                              name="gender"
                              value={genderArr.trans_gender}
                            >
                              {t("TRANS_GENDER")}
                            </Radio>
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="flex-container">
                      <>
                        <Field name="new_building">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <Checkbox
                                name="new_building"
                                checked={
                                  input.value === onOffArr.on ? true : false
                                }
                                onChangeCapture={(e: any) => {
                                  if (e.target.checked) {
                                    form.change("new_building", onOffArr.on);
                                    setCreateNewBuilding(true);
                                  } else {
                                    form.change("new_building", onOffArr.off);
                                    setCreateNewBuilding(false);
                                  }
                                }}
                                value={onOffArr.on}
                              ></Checkbox>
                              <label className="inline">
                                {t("NEW")} {t("SOCIETY")}
                              </label>
                            </div>
                          )}
                        </Field>
                        {createNewBuilding ? (
                          <Field
                            name="building"
                            validate={
                              ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                            }
                          >
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label className="inline">{t("SOCIETY")}</label>
                                <input
                                  {...input}
                                  type="text"
                                  disabled={
                                    form.getState().values.city_id
                                      ? false
                                      : true
                                  }
                                  autoComplete="off"
                                  onChange={(event: any) => {
                                    form.change("building", event.target.value);
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                        ) : (
                          <Field name="building_id">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <CustomSelector
                                  loaderMsg={
                                    form.getState().values.building_id &&
                                    !buildingList?.length
                                      ? t("FETCHING_DATA_OF", {
                                          field: t("SOCIETY"),
                                        })
                                      : ""
                                  }
                                  valueKey="id"
                                  labelKey="building_name"
                                  isRequired={false}
                                  isDisable={
                                    !buildingList?.length ? true : false
                                  }
                                  labelName={t("SOCIETY")}
                                  defaultValue={input.value}
                                  onClear={(event: any) => {
                                    resetSelectionFor("building", form);
                                  }}
                                  listData={
                                    form.getState().values.area_id &&
                                    buildingList?.length
                                      ? buildingList
                                      : [{}]
                                  }
                                  onSelect={(e: any, selectedObj: any) => {
                                    handleBuildingChange(e, form);
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                                {meta.error &&
                                  meta.touched &&
                                  form.getState().values.area_id &&
                                  !buildingList?.length && <br />}
                                {form.getState().values.area_id &&
                                  !buildingList?.length &&
                                  !buildingNotFound && (
                                    <span>
                                      {t("FETCHING_DATA_OF", {
                                        field: t("SOCIETY").toLocaleLowerCase(),
                                      })}
                                    </span>
                                  )}
                                {form.getState().values.area_id &&
                                  buildingNotFound && (
                                    <span>
                                      {t("NO_DATA_FOUND_OF", {
                                        field: t("SOCIETY").toLocaleLowerCase(),
                                      })}
                                    </span>
                                  )}
                              </div>
                            )}
                          </Field>
                        )}
                      </>
                      <>
                        <Field name="new_area">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <Checkbox
                                name="new_area"
                                checked={
                                  input.value === onOffArr.on ? true : false
                                }
                                onChangeCapture={(e: any) => {
                                  if (e.target.checked) {
                                    form.change("new_area", onOffArr.on);
                                    form.change("new_building", onOffArr.on);
                                    setCreateNewArea(true);
                                    setCreateNewBuilding(true);
                                  } else {
                                    form.change("new_area", onOffArr.off);
                                    form.change("new_building", onOffArr.off);
                                    setCreateNewArea(false);
                                    setCreateNewBuilding(false);
                                  }
                                }}
                                value={onOffArr.on}
                              ></Checkbox>
                              <label className="inline">
                                {t("NEW")} {t("AREA")}
                              </label>
                            </div>
                          )}
                        </Field>
                        {createNewArea ? (
                          <Field
                            name="area_name"
                            validate={
                              ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                            }
                          >
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label className="inline">{t("AREA")}</label>
                                <input
                                  {...input}
                                  type="text"
                                  disabled={
                                    form.getState().values.city_id
                                      ? false
                                      : true
                                  }
                                  autoComplete="off"
                                  onChange={(event: any) => {
                                    form.change(
                                      "area_name",
                                      event.target.value
                                    );
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                        ) : (
                          <Field name="area_id">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <CustomSelector
                                  loaderMsg={
                                    form.getState().values.area_id &&
                                    !areaList?.length
                                      ? t("FETCHING_DATA_OF", {
                                          field: t("AREA"),
                                        })
                                      : ""
                                  }
                                  valueKey="id"
                                  labelKey="area_name"
                                  isRequired={false}
                                  isDisable={!areaList?.length ? true : false}
                                  labelName={t("AREA")}
                                  defaultValue={input.value}
                                  onClear={(event: any) => {
                                    resetSelectionFor("area", form);
                                  }}
                                  listData={
                                    form.getState().values.city_id &&
                                    areaList?.length
                                      ? areaList
                                      : [{}]
                                  }
                                  onSelect={(e: any, selectedObj: any) => {
                                    handleAreaChange(e, form);
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                                {meta.error &&
                                  meta.touched &&
                                  form.getState().values.city_id &&
                                  !areaList?.length && <br />}
                                {form.getState().values.city_id &&
                                  !areaList?.length &&
                                  !areaNotFound && (
                                    <span>
                                      {t("FETCHING_DATA_OF", {
                                        field: t("AREA").toLocaleLowerCase(),
                                      })}
                                    </span>
                                  )}
                                {form.getState().values.city_id &&
                                  areaNotFound && (
                                    <span>
                                      {t("NO_DATA_FOUND_OF", {
                                        field: t("AREA").toLocaleLowerCase(),
                                      })}
                                    </span>
                                  )}
                              </div>
                            )}
                          </Field>
                        )}
                      </>
                    </div>
                    <div className="flex-container">
                      <Field name="city_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={
                                form.getState().values.state_id &&
                                !cityList?.length
                                  ? t("FETCHING_DATA_OF", { field: t("CITY") })
                                  : ""
                              }
                              valueKey="id"
                              labelKey="city_name"
                              isRequired={false}
                              isDisable={!cityList?.length ? true : false}
                              labelName={t("CITY")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                resetSelectionFor("city", form);
                              }}
                              listData={
                                form.getState().values.state_id &&
                                cityList?.length
                                  ? cityList
                                  : [{}]
                              }
                              onSelect={(e: any, selectedObj: any) => {
                                handleCityChange(e, form);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                            {meta.error &&
                              meta.touched &&
                              form.getState().values.state_id &&
                              !cityList?.length && <br />}
                            {form.getState().values.state_id &&
                              !cityList?.length &&
                              !cityNotFound && (
                                <span>
                                  {t("FETCHING_DATA_OF", {
                                    field: t("CITY").toLocaleLowerCase(),
                                  })}
                                </span>
                              )}
                            {form.getState().values.state_id &&
                              cityNotFound && (
                                <span>
                                  {t("NO_DATA_FOUND_OF", {
                                    field: t("CITY").toLocaleLowerCase(),
                                  })}
                                </span>
                              )}
                          </div>
                        )}
                      </Field>
                      <Field name="state_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={
                                form.getState().values.country_id &&
                                !stateList?.length
                                  ? t("FETCHING_DATA_OF", {
                                      field: t("STATE").toLocaleLowerCase(),
                                    })
                                  : ""
                              }
                              valueKey="id"
                              labelKey="state_name"
                              isRequired={false}
                              isDisable={!stateList?.length ? true : false}
                              labelName={t("STATE")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                resetSelectionFor("state", form);
                              }}
                              listData={
                                form.getState().values.country_id &&
                                stateList?.length
                                  ? stateList
                                  : [{}]
                              }
                              onSelect={(e: any, selectedObj: any) => {
                                handleStateChange(e, form);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                            {meta.error &&
                              meta.touched &&
                              form.getState().values.country_id &&
                              !stateList?.length && <br />}
                            {form.getState().values.country_id &&
                              !stateList?.length &&
                              !stateNotFound && (
                                <span>
                                  {t("FETCHING_DATA_OF", { field: t("STATE") })}
                                </span>
                              )}
                            {form.getState().values.country_id &&
                              !stateList?.length &&
                              stateNotFound && (
                                <span>
                                  {t("NO_DATA_FOUND_OF", {
                                    field: t("STATE").toLocaleLowerCase(),
                                  })}
                                </span>
                              )}
                          </div>
                        )}
                      </Field>
                      <Field name="country_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={t("FETCHING_DATA_OF", {
                                field: t("COUNTRY").toLocaleLowerCase(),
                              })}
                              isRequired={false}
                              valueKey="id"
                              labelKey="country_name"
                              isDisable={!countryList?.length ? true : false}
                              labelName={t("COUNTRY")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                resetSelectionFor("country", form);
                              }}
                              listData={countryList?.length ? countryList : []}
                              onSelect={(e: any, selectedObj: any) => {
                                handleCountryChange(e, form);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="create-action d-flex flex-end">
                    {withCancelButton && (
                      <Link to={ContentRoutes.CAMPAIGNS}>
                        <Button appearance="primary" color="red" type="button">
                          {t("CANCEL")}
                        </Button>
                      </Link>
                    )}
                    <Button appearance="primary" color="green" type="submit">
                      {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                    </Button>
                    <Button
                      appearance="default"
                      type="reset"
                      onClick={() => {
                        // review comment: move to new function
                        form.reset();
                        setIsUsernameAllowed(true);
                        if (form.getState().values.country_id) {
                          handleCountryChange(
                            form.getState().values.country_id
                          );
                        }
                        if (form.getState().values.state_id) {
                          handleStateChange(form.getState().values.state_id);
                        }
                      }}
                    >
                      {t("RESET")}
                    </Button>
                  </div>
                </form>
              )}
            />
          </Content>
        </Container>
      </div>
    </div>
  );
}

export default CampaignCustomer;
